export enum FormLayout {
  LAYOUT1 = 'form_layout1',
  LAYOUT1_SUCCESS = 'form_layout1_success',
  LAYOUT2 = 'form_layout2',
  LAYOUT2_SUCCESS = 'form_layout2_success',
  LAYOUT3 = 'form_layout3',
  LAYOUT3_SUCCESS = 'form_layout3_success',
  LAYOUT4 = 'form_layout4',
}
